import React from 'react';
import Icon from '../../../components/AppIcon';

const RisksSection = ({ risks, confidence }) => {
  return (
    <div className="w-full bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-elevation-sm">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-warning/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} color="var(--color-warning)" />
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
            Risks &amp; Unknowns
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Shield" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground text-caption">
            <span className="font-semibold text-data">{confidence}%</span>
          </span>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {risks?.map((risk, index) => (
          <div 
            key={index}
            className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-warning/5 border border-warning/20 hover:bg-warning/10 transition-base"
          >
            <div className="flex-shrink-0 mt-1">
              <div className="w-6 h-6 rounded-full bg-warning/20 flex items-center justify-center">
                <Icon name="AlertCircle" size={14} color="var(--color-warning)" />
              </div>
            </div>
            <p className="text-sm md:text-base text-foreground leading-relaxed font-body flex-1">
              {risk}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-border">
        <div className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-primary/5">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <p className="text-sm text-muted-foreground font-body">
            These risks should be investigated further through building inspections, pest reports, and direct questions to the selling agent.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RisksSection;